var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagInactiveWithoutCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:inline;fill:none;stroke:#A3D7EE;}\n\t.st3{fill:none;stroke:#000000;stroke-linecap:round;}\n\t.st4{fill:none;stroke:#000000;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    transform: "translate(-971 -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    transform: "translate(971 407)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12,
    cy: 12,
    r: 11.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    transform: "translate(8.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    className: "st3",
    x1: 971.5,
    y1: 414,
    x2: 971.5,
    y2: 424
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    className: "st4",
    d: "M971.5,414h8l-2,2.6l2,2.4h-8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    className: "st3",
    x1: 970.5,
    y1: 424.5,
    x2: 972.5,
    y2: 424.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagInactiveWithoutCircle);
export default __webpack_public_path__ + "static/media/flag_inactive-without-circle.fb8b9587aa8cf67be23f13eed3598cb4.svg";
export { ForwardRef as ReactComponent };